function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { appConfigApi } from '@/api/public';
import { roterPre } from '@/settings';
import Cookies from 'js-cookie';
import { generateTitle } from '@/utils/i18ns';
import defaultSettings from '@/settings';
export default {
  components: {
    configapp: function configapp() {
      return import('./ConfigApp/index');
    },
    headerNotice: function headerNotice() {
      return import('./Notice/index');
    },
    notepad: function notepad() {
      return import('./Notepad/notepad');
    },
    personal: function personal() {
      return import('./Personal/index');
    }
  },
  props: ['type'],
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'sidebarParentCur', 'menuList', 'enterprise'])), {}, {
    newMenuListArr: function newMenuListArr() {
      return this.menuList.filter(function (val) {
        return val.is_show !== 0;
      });
    },
    activeMenus: function activeMenus() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  }),
  data: function data() {
    return {
      roterPre: roterPre,
      adminInfo: Cookies.set('AdminName'),
      levelList: null,
      parentcur: this.sidebarParentCur,
      webConfig: null,
      showMax: 5,
      newMenuList: [],
      showMore: true
    };
  },
  watch: {
    $route: function $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created: function created() {
    var _this = this;
    appConfigApi().then(function (res) {
      _this.webConfig = res.data;
      localStorage.setItem('isWebConfig', res.data.global_watermark_status);
      localStorage.setItem('webConfig', JSON.stringify(res.data));
      // 加入企业
      if (res.data.enterprise_name) {
        defaultSettings.title = res.data.enterprise_name;
        document.title = res.data.enterprise_name;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.getBreadcrumb();
    this.getShowMore();
    window.addEventListener('resize', function () {
      _this2.getShowMore();
    });
  },
  methods: {
    getShowMore: function getShowMore() {
      var navHeight = 60;
      var height = this.$refs.leftBox.clientHeight;
      var len = this.newMenuListArr.length;
      this.showMore = navHeight * len <= height;
      this.showMax = Math.floor(height / navHeight) - 1;
    },
    generateTitle: generateTitle,
    getBreadcrumb: function getBreadcrumb() {
      // only show routes with meta.title
      var matched = this.$route.matched.filter(function (item) {
        return item.meta && item.meta.title;
      });
      this.levelList = matched.filter(function (item) {
        return item.meta && item.meta.title && item.meta.breadcrumb !== false;
      });
      if (this.activeMenus === "".concat(roterPre, "/dashboard")) {
        return this.$store.commit('app/SET_PARENTCUR', 2);
      }
      this.filterArr(this.menuList, this.activeMenus);
    },
    // 父级菜单切换
    handleParentCur: function handleParentCur(index, type, row) {
      if (type === 1) {
        this.parentcur = index;
        this.$store.commit('app/SET_CLICK_TAB', true);
        this.$store.commit('app/SET_PARENTCUR', this.parentcur);
      } else {
        this.parentcur = new Date().getTime() + "".concat(this.showMax - 1);
        var len4 = this.menuList[this.showMax - 1];
        this.menuList[this.showMax - 1] = row;
        this.menuList[this.showMax + index] = len4;
        this.$store.commit('user/SET_MENU_LIST', this.menuList);
        this.$store.commit('app/SET_CLICK_TAB', true);
        this.$store.commit('app/SET_PARENTCUR', this.parentcur);
      }
    },
    filterArr: function filterArr(arr, url) {
      var self = this;
      var recursiveFunction = function recursiveFunction(url) {
        var _getStr = function getStr(arr) {
          arr.forEach(function (row) {
            if (row.children) {
              _getStr(row.children);
            } else {
              if (row.menu_path === url) {
                if (row.path[0]) {
                  self.getParentIndex(row.path[0]);
                }
              }
            }
          });
        };
        _getStr(arr);
      };
      recursiveFunction(url);
    },
    // 设置父级下标
    getParentIndex: function getParentIndex(pid) {
      var _this3 = this;
      this.menuList.forEach(function (item, index) {
        if (item.id === pid) {
          _this3.parentcur = index;
          _this3.$store.commit('app/SET_PARENTCUR', index);
        }
      });
    }
  }
};